const getWindow = () => (globalThis.window === undefined ? undefined : globalThis.window);

const normalizeDelay = (delay: number): number => {
  if (!Number.isFinite(delay)) {
    return 0;
  }
  if (delay <= 0) {
    return 0;
  }
  // Clamp to the maximum delay supported by setTimeout to avoid overflow warnings.
  return Math.min(delay, 2_147_483_647);
};

export const setWindowTimeout = (callback: () => void, delay: number): number | null => {
  const win = getWindow();
  if (!win || typeof win.setTimeout !== 'function') {
    return null;
  }
  const clampedDelay = normalizeDelay(delay);
  return win.setTimeout(callback, clampedDelay);
};

export const clearWindowTimeout = (handle: number | null | undefined): void => {
  const win = getWindow();
  if (!win || handle == null || typeof win.clearTimeout !== 'function') {
    return;
  }
  win.clearTimeout(handle);
};

export const setWindowInterval = (callback: () => void, delay: number): number | null => {
  const win = getWindow();
  if (!win || typeof win.setInterval !== 'function') {
    return null;
  }
  const clampedDelay = normalizeDelay(delay);
  return win.setInterval(callback, clampedDelay);
};

export const clearWindowInterval = (handle: number | null | undefined): void => {
  const win = getWindow();
  if (!win || handle == null || typeof win.clearInterval !== 'function') {
    return;
  }
  win.clearInterval(handle);
};

export const requestWindowAnimationFrame = (callback: FrameRequestCallback): number | null => {
  const win = getWindow();
  if (!win || typeof win.requestAnimationFrame !== 'function') {
    return null;
  }
  return win.requestAnimationFrame(callback);
};

export const cancelWindowAnimationFrame = (handle: number | null | undefined): void => {
  const win = getWindow();
  if (!win || handle == null || typeof win.cancelAnimationFrame !== 'function') {
    return;
  }
  win.cancelAnimationFrame(handle);
};
